// extracted by mini-css-extract-plugin
export default {"carT_foot":"index_carT_foot_LsyiW","col_w1000":"index_col_w1000_-9rKb","space01":"index_space01_uUOoP","bottom1Ad":"index_bottom1Ad_gtVeq"};